<template>
    <div class="wallet-nfts container">
        <loading-spinner v-if="!areNftsFetched"
            class="wallet-nfts__spinner"
        />
        <nft-list v-else
            :class="['wallet-nfts__list', { 'wallet-nfts__list-empty': !getFormattedNftsList.length }]"
            :nfts="getFormattedNftsList"
        />
    </div>
</template>

<script>
// 3rd party libs
import {
    mapGetters,
    mapActions,
} from 'vuex';

// Components
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';
import nftList from '@webapp/modules/crypto-and-trading/components/nft/list.vue';


export default {
    name: 'wallet-digital-collectibles',
    components: {
        loadingSpinner,
        nftList,
    },
    data: () => ({
        areNftsFetched: false,
    }),
    computed: {
        ...mapGetters('nfts', ['getFormattedNftsList']),
    },
    async mounted() {
        await this.fetchNFTs({
            limit: 1000,
        });

        this.areNftsFetched = true;
    },
    methods: {
        ...mapActions('nfts', ['fetchNFTs']),
    },
};
</script>

<style lang="scss" scoped>
@import "@webapp/modules/crypto-and-trading/styles/wallet/common.scss";

.wallet-nfts {
    padding-bottom: 2.5rem;
    width: 100%;

    &__spinner {
        width: unset;
    }

    &__list {
        padding: 0 9rem;

        &-empty {
            padding: unset;
        }

        @include min-width(md) {
            padding: unset;
        }
    }
}
</style>